




























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import LocationTypes from '@/components/LocationTypes/LocationTypes.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';
import EmailTemplates from '@/components/EmailTemplates/EmailTemplates.vue';

@Component({
	name: 'AgencyEmailTemplateSettings',
  	components: { EmailTemplates, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getEmailTemplates();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingEmailTemplates;
  	}
}
